import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const TermsOfService = () => (
  <Container maxWidth="md" sx={{ py: 6 }}>
    <Typography variant="h4" gutterBottom>Terms of Service</Typography>
    <Box sx={{ color: 'text.secondary', mt: 2 }}>
      <Typography paragraph>
        By using our app, you agree to these Terms of Service. Please read them carefully.
      </Typography>
      <Typography variant="h6" gutterBottom>Use of Service</Typography>
      <Typography paragraph>
        You agree to use our services only for lawful purposes and in accordance with these terms.
      </Typography>
      <Typography variant="h6" gutterBottom>Account Responsibility</Typography>
      <Typography paragraph>
        You are responsible for maintaining the confidentiality of your account and password.
      </Typography>
      <Typography variant="h6" gutterBottom>Prohibited Activities</Typography>
      <Typography paragraph>
        You may not use our services for any illegal or unauthorized purpose.
      </Typography>
      <Typography variant="h6" gutterBottom>Termination</Typography>
      <Typography paragraph>
        We reserve the right to suspend or terminate your access to the service at any time, without notice, for conduct that we believe violates these terms.
      </Typography>
      <Typography variant="h6" gutterBottom>Changes to Terms</Typography>
      <Typography paragraph>
        We may update these Terms of Service from time to time. Continued use of the service constitutes acceptance of the new terms.
      </Typography>
      <Typography variant="h6" gutterBottom>Contact Us</Typography>
      <Typography paragraph>
        If you have any questions about these Terms of Service, please contact us at hello@finextra.app.
      </Typography>
    </Box>
  </Container>
);

export default TermsOfService; 